import React, { useState, useEffect } from 'react';

const FloatingCTA = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling past hero (approx 500px)
      setVisible(window.scrollY > 500);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className={`floating-cta-bar ${visible ? 'floating-cta-bar--visible' : ''}`}>
      <div className="floating-cta-left">
        <span className="floating-cta-title">System Design Masterclass</span>
        <span className="floating-cta-sub">by SweetCodey</span>
      </div>
      <a href="#courses" className="floating-cta-btn">
        View Course →
      </a>
    </div>
  );
};

export default FloatingCTA;
